import correctIcon from '@/assets/paper-collect/correct-icon.png'
import failIcon from '@/assets/paper-collect/fail-icon.png'
import correctDisabledIcon from '@/assets/paper-collect/correct-disabled-icon.png'
import failDisabledIcon from '@/assets/paper-collect/fail-disabled-icon.png'

export const judgeList = ['√', '×']
export const judgeMap = {
  '√': {
    normalIcon: correctIcon,
    disabledIcon: correctDisabledIcon
  },
  '×': {
    normalIcon: failIcon,
    disabledIcon: failDisabledIcon
  }
}
export const judgeTextMap = {
  E: '√',
  F: '×'
}

// 作答状态
export const answerStateMap = {
  // 初始化
  init: 1,
  // 作答中
  answering: 2,
  // 作答结束
  answerEnd: 3
}

// 答案对应的色值
export const answerColorMap = {
  // 未设置答案
  null: {
    bgColor: '#E8F1FF',
    color: '#1976FF'
  },
  // 正确答案
  true: {
    bgColor: '#E8F9EF',
    color: '#1DC060'
  },
  // 错误答案
  false: {
    bgColor: '#FFEBEA',
    color: '#FF3C30'
  }
}

// 小题类型枚举
export const smallQuestionTypeEnum = {
  singleChoose: 1,
  multipleChoose: 2
}

// 小题类型映射
export const smallQuestionTypeMap = {
  [smallQuestionTypeEnum.singleChoose]: {
    label: '单选',
    value: 1
  },
  [smallQuestionTypeEnum.multipleChoose]: {
    label: '多选',
    value: 2
  }
}

export const smallQuestionTypeList = Object.entries(smallQuestionTypeMap).map(([k, v]) => ({
  label: v.label,
  value: v.value
}))

export const listeningMaterialType = {
  chapter: 'chapter', //篇章
  dialogue: 'dialogue' // 对话
}
